<template>
  <div id="app">
    <SiteHeader
      :menu-items="menuItems"
      @search="onSearch"
      @quote="onQuote"
    />
    <router-view/>
    <SiteFooter @contact="onContact" />
    <ContactSidebar />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import ContactSidebar from '@/components/ContactSidebar.vue'

export default {
  name: 'App',
  components: { SiteHeader, SiteFooter, ContactSidebar },
  data() {
    return {
    
    }
  },
	computed: {
    menuItems() {
      return [
        { label: this.$t('首页'), path: '/' },
        {
          label: this.$t('产品'),
          path: '/product',
          children: [
            { label: this.$t('柴油发电机组'), path: `/category/${this.$t('柴油发电机组')}` },
            { label: this.$t('空气压缩机'), path: `/category/${this.$t('空气压缩机')}` },
            { label: this.$t('移动照明灯车'), path: `/category/${this.$t('移动照明灯车')}` },
            { label: this.$t('冷藏发电机'), path: `/category/${this.$t('冷藏发电机')}` },
            { label: this.$t('燃气发电机组'), path: `/category/${this.$t('燃气发电机组')}` },
            { label: this.$t('电焊机'), path: `/category/${this.$t('电焊机')}` },
            { label: this.$t('其他的'), path: `/category/${this.$t('其他的')}` }
          ]
        },
        { label: this.$t('行业'), path: '/industry' },
        { label: this.$t('支持'), path: '/service',
          children: [
            // { label: '下载中心', path: '/download' },
            // { label: '视频', path: '/video' },
            { label: this.$t('售后服务'), path: '/service' },
          ]
        },
        { label: this.$t('关于我们'), path: '/aboutus',
          children: [
            { label: this.$t('公司简介'), path: '/aboutus' },
            { label: this.$t('证书展示'), path: '/certificate' },
            { label: this.$t('可持续发展'), path: '/sustainability' },
          ]
        },
        { label: this.$t('博客'), path: '/news' }
      ]
    }
	},
  methods: {
    onSearch(value) {
      console.log('search:', value)
    },
    onQuote() {
      console.log('quote click')
    },
    onContact(payload) {
      console.log('contact submit:', payload)
    }
  }
}
</script>

<style>
/* 全局：去除默认边距与滚动条 */
html, body, #app { height: 100%; }
html, body { margin: 0; padding: 0; overflow-x: hidden; }
/* 隐藏竖向滚动条但保留滚动能力 */
html { -ms-overflow-style: none; scrollbar-width: none; }
html::-webkit-scrollbar { width: 0; height: 0; }
body { -ms-overflow-style: none; scrollbar-width: none; }
body::-webkit-scrollbar { width: 0; }

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
